import Cookies from 'js-cookie';

const PREFILL_COOKIE = 'customerPreFill';
const COOKIE_EXPIRES_DAYS = 365;

const PREFILL_FIELDS = [
    'name', 'email', 'phone', 'instagram',
    'cpfCnpj', 'rg', 'birthDate',
    'cep', 'address', 'addressNumber', 'addressComplement',
    'neighborhood', 'city', 'state',
];

export function getPreFillData() {
    try {
        const raw = Cookies.get(PREFILL_COOKIE);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function savePreFillData(formData) {
    const data = {};
    PREFILL_FIELDS.forEach(field => {
        if (formData[field] !== undefined && formData[field] !== null && formData[field] !== '') {
            data[field] = formData[field];
        }
    });
    Cookies.set(PREFILL_COOKIE, JSON.stringify(data), { expires: COOKIE_EXPIRES_DAYS, path: '/' });
}
